import {useCallback, useState} from 'react'

import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useSearchParams} from '@github-ui/use-navigate'

import {agentFinderRoute} from '../agent-finder-route'

import {Content} from './_components/Content/Content'
import {Header} from './_components/Header/Header'

const SEARCH_PARAM = 'search'

export function AgentFinder() {
  const payload = useRouteQuery(agentFinderRoute, 'mainQuery')
  const [searchParams, setSearchParams] = useSearchParams()

  const [searchQuery, setSearchQuery] = useState(searchParams.get(SEARCH_PARAM) || '')

  const handleSearchChange = useCallback(
    (query: string) => {
      setSearchQuery(query)

      const newSearchParams = new URLSearchParams(searchParams)
      if (query.trim()) {
        newSearchParams.set(SEARCH_PARAM, query.trim())
      } else {
        newSearchParams.delete(SEARCH_PARAM)
      }

      newSearchParams.delete('page')

      setSearchParams(newSearchParams, {preventAutofocus: true})
    },
    [searchParams, setSearchParams],
  )

  return (
    <>
      <Header searchQuery={searchQuery} onSearchChange={handleSearchChange} />
      <Content
        key={searchParams.get(SEARCH_PARAM) || 'all'}
        catalogData={payload.data.catalogData}
        resourceTypes={payload.data.resourceTypes ?? []}
      />
    </>
  )
}
